import React, { useState, useCallback, useMemo, useContext, useEffect } from "react";
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import styled from "styled-components";
import useEntitesTable from "./useEntitesTable.js";
import Button from "components/CustomButtons/Button.js";
import CustomDeleteDialog from "../CustomDeleteDialog/CustomDeleteDialog.js";
import CustomDeleteButton from "../CustomDeleteButton/CustomDeleteButton.js";
import { withStyles } from "@mui/styles";
import { makeStyles } from "@mui/styles";
import Dialog from "@mui/material/Dialog";
import MuiDialogTitle from "@mui/material/DialogTitle";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import LinearProgress from "@mui/material/LinearProgress";
import AddIcon from "@mui/icons-material/Add";
import Chip from "@mui/material/Chip";
import Grid from "@mui/material/Grid";
import EditIcon from "@mui/icons-material/Edit";
import EditUserDialog from "./EditUserDialog";
import UserService from "services/UserService";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { deleteUser } from "../../services/ConfigServices";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import "assets/css/customNotifications.css";
import ReactLoading from "react-loading";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
//import "react-table/react-table.css";

// @mui/icons-material
import GetAppIcon from "@mui/icons-material/GetApp";
import Person from "@mui/icons-material/Person";
import Edit from "@mui/icons-material/Edit";
import Close from "@mui/icons-material/Close";
import ViewLogDialog from "./ViewLogDialog";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";

//import Button from "components/CustomButtons/Button.js";

import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";

const useStyles = makeStyles(styles);

const LoadingDiv = styled.div`
  height: 20vh;
  width: 20vw;
  display: flex;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  padding-top: 10vh;
`;

const Container = styled.div`
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.15);
  border-top: 4px solid rgba(255, 255, 255, 1);
  background-color: white;
  margin-top: -2px;
`;

const ExpandableContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin: 1rem 4rem;
`;
const ExpandableElement = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: ${(props) => props.marginleft};
`;
const ElementData = styled.div`
  font-weight: 400;
  font-size: 13px;
`;
const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;

const GroupCell = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const styless = (theme) => ({
  root: {
    margin: 0,
    padding: '16px',
  },
  closeButton: {
    position: "absolute",
    right: '8px',
    top: '8px',
    color: '#9e9e9e',
  },
  button: {
    backgroundColor: "",
    bordertopleftradius: 0,
    borderbottomleftradius: 0,
    bordertoprightradius: "5px",
    borderbottomrightradius: "5px",
    height: "34px",
    width: "32px",
    textalign: "center",
    display: "flex",
    alignitems: "center",
    justifycontent: "center",
    "&:hover": {
      cursor: "pointer",
    },
  },
});

const DialogTitle = withStyles(styless)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const RTUtilisateurs = () => {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const users_update = permis.includes("users_update");
  const currentusertype = localStorage.getItem('userType');
  const appContext = useContext(AdvancedSearchContext);
  const { groupInfoListById, setPage } = appContext;
  const {
    gridState,
    error,
    refreshTable,
    permissionList,
    viewList,
    setLoading,
    setUsers,
  } = useEntitesTable();

  useEffect(() => {
    setPage('users');
  }, []);


  const [open, setOpen] = useState(false);
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [phonenumber, setPhonenumber] = useState("");
  const [userType, setUserType] = useState("");
  const [permissionName, setPermissionName] = useState("");
  const [userid, setUserid] = useState("");
  const [userView, setUserView] = useState("");
  const [userPermission, setUserPermission] = useState("");
  const [userGroups, setUserGroups] = useState([]);
  const [memv2version, setMemv2version] = React.useState("");
  const [options, setOptions] = useState([]);
  const [user, setUser] = useState("");
  const [openLog, setOpenLog] = useState(false);

  const updateState = useCallback((state) => console.log(state));

  const classes = useStyles();

  const fillButtons = [
    { color: "success", icon: Edit },
    { color: "danger", icon: Close },
  ].map((prop, key) => {
    return (
      <Button
        color={prop.color}
        className={classes.actionButton}
        key={key}
        onClick={prop.onClick}
      >
        <prop.icon className={classes.icon} />
      </Button>
    );
  });

  let dataUsers = gridState.data;

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleViewLogOpen = () => {
    setOpenLog(true);
  };
  const handleViewLogClose = () => {
    setOpenLog(false);
  };

  if (error) {
    return (
      <p>
        <span role="img" aria-label="Problem">
          🔧
        </span>{" "}
        Il semble y avoir une erreur...{" "}
        <button onClick={refreshTable()}>Relancer</button>
      </p>
    );
  }

  const columns = [
    {
      name: "Nom",
      selector: (row) => row.lastname,
      sortable: true,
      maxWidth: "10rem",
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div className="actions-right">
            {row.lastname} {row.firstname}
          </div>
        </>
      ),
    },
    {
      name: "Login/Email",
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: "Type",
      selector: (row) => row.usertype,
      sortable: true,
      minWidth: "10rem",
      // eslint-disable-next-line react/display-name
      cell: (row) =>
        row.usertype == 0
          ? "Utilisateur"
          : row.usertype == 1
            ? "Administrateur"
            : row.usertype == 2
              ? "Administrateur local"
              : "Administrateur MEM",
    },
    {
      name: "Vue",
      selector: (row) => row.viewname,
      sortable: true,
    },
    {
      name: "Permissions",
      selector: (row) => row.permissionname,
      sortable: true,
    },
    {
      name: "Groupes",
      selector: (row) => row.usergrouplist,
      sortable: true,
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <GroupCell>
          {row.usergrouplist?.map((groupid) => {
            return (
              <Chip label={groupInfoListById["" + groupid]} key={groupid} />
            );
          })}
        </GroupCell>
      ),
    },
    {
      name: "Dernière connexion",
      selector: (row) => row.lastconnection || 0,
      sortable: true,
      maxWidth: "8rem",
      cell: (row) => row.lastconnection && moment(row.lastconnection).isValid()
        ? moment(row.lastconnection).format("DD/MM/YYYY HH:mm")
        : "",
    },
    {
      name: "Actions",
      sortable: true,
      width: "10rem",
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div className="actions-right">
            {currentusertype == 1 &&
              <Tooltip title="Voir les logs">
                <Button
                  onClick={viewPointData(row)}
                  color={"info"}
                  className={classes.actionButton}
                >
                  <VisibilityIcon fontSize="large" />
                </Button>
              </Tooltip>
            }
            {users_update &&
              <>
                <Button
                  color={"success"}
                  className={classes.actionButton}
                  onClick={editUser(row)}
                >
                  <Edit className={classes.icon} />
                </Button>

                <CustomDeleteButton
                  deleteTitle={"Suppression utilisateur"}
                  deleteSubTitle={
                    "Êtes-vous sûr de vouloir supprimer l'utilisateur ?"
                  }
                  handleSupprimer={deleteUserSelected(row)}
                /></>}
          </div>
        </>
      ),
    },
  ];

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const viewPointData = (row) => async () => {
    let obj = dataUsers.find((o) => o.id === row.id);
    setUser(obj);
    handleViewLogOpen();
  };

  const editUser = (row) => async () => {
    let obj = dataUsers.find((o) => o.id === row.id);
    let idSelected = obj.id;
    console.log(obj);
    handleClickOpen();
    setFirstname(obj.firstname);
    setLastname(obj.lastname);
    setEmail(obj.email);
    setPhonenumber(obj.phonenumber || '');
    setUserType(obj.usertype);
    setPermissionName(obj.permissionname);
    setUserid(obj.id);
    setUserView(obj.userview);
    setUserPermission(obj.userpermission);
    setUserGroups(obj.usergrouplist);
    setMemv2version(obj.memv2version);
    setOptions(obj.options);
  };

  const deleteUserSelected = (row) => async () => {
    setLoading(true);
    let obj = dataUsers.find((o) => o.id === row.id);
    console.log(obj);
    let idSelected = obj.id;
    console.log(idSelected);
    axios
      .delete(deleteUser(idSelected), {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        if (res.status == 200)
          NotificationManager.success("L'utilisateur a bien été supprimé");
        else NotificationManager.error("Un problème est survenu");
        refreshTable();
      });
  };

  const handleSelectedRowsChange = (selection) => {
    setUsers(selection.selectedRows);
  };

  return (
    <>
      <DataTable
        paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
        noDataComponent={<NoData>Aucun utilisateur à afficher</NoData>}
        columns={columns}
        persistTableHead
        pagination
        noHeader={true}
        subHeader
        onSelectedRowsChange={handleSelectedRowsChange}
        selectableRows={true}
        paginationComponentOptions={{
          noRowsPerPage: false,
          rowsPerPageText: "Lignes par page",
          rangeSeparatorText: "sur",
          selectAllRowsItem: false,
          selectAllRowsItemText: "Selectionner toutes les lignes",
        }}
        progressPending={gridState.loading}
        progressComponent={
          <div>
            <LoadingDiv>
              <ReactLoading
                type={"bars"}
                color={"#91c241"}
                height={"10%"}
                width={"10%"}
              />
            </LoadingDiv>
          </div>
        }
        {...gridState}
      />

      <Dialog
        onClose={handleClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth={true}
        maxWidth="md"
        open={open}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleClose}>
          Modifier l'utilisateur
        </CustomDialogTitle>
        <DialogContent dividers>
          <EditUserDialog
            closeModal={handleClose}
            firstNameValue={firstname}
            lastNameValue={lastname}
            emailValue={email}
            phonenumber={phonenumber}
            userid={userid}
            usertype={userType}
            userpermission={userPermission}
            userview={userView}
            usergroups={userGroups}
            memv2version={memv2version}
            options={options}
            permissionlist={permissionList}
            viewlist={viewList}
            setLoading={setLoading}
            setNotification={setNotification}
            refetch={refreshTable}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
      <Dialog
        onClose={handleViewLogClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="md"
        open={openLog}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleViewLogClose}>
          Logs de {user?.firstname} {user?.lastname}
        </CustomDialogTitle>
        <DialogContent dividers>
          <ViewLogDialog
            user={user}
            closeModal={handleViewLogClose}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </>
  );
};

export default RTUtilisateurs;
